import {Howl} from 'howler';
import store from '../../store/configure-store';
import { setSoundsLoaded } from '../../store/entities/sounds-loaded-slice';
import { assets } from '../../assets';
//var VOLUME = 0.085;

class MusicPlayer {
  constructor() {
    if (MusicPlayer.instance == null) { 
      this.enabled = false;
      this.sound_files = {
        rr_trafficambience_loop : new Howl({
            src: [assets.musicLoop],
            volume: store.getState().musicVolume || 0.085,
            onload: () => {
              store.dispatch(setSoundsLoaded(true));
            }
        })
      };
      this.initUserInteraction();
      MusicPlayer.instance = this;
    }
    
    return MusicPlayer.instance;
  }

  initUserInteraction() {
    const enableSounds = () => {
      // Attempt to play a sound or initialize sound objects to unblock audio playback
      this.sound_files.rr_trafficambience_loop.loop();
      this.sound_files.rr_trafficambience_loop.play();
      this.enabled = true;
      // Remove the interaction listeners after the first interaction
      document.removeEventListener('click', enableSounds);
      document.removeEventListener('keydown', enableSounds);
      document.removeEventListener('touchstart', enableSounds);
    };

    // Add event listeners for the first interaction
    document.addEventListener('click', enableSounds);
    document.addEventListener('keydown', enableSounds);
    document.addEventListener('touchstart', enableSounds);
  }

  /**
   * Plays the filename from SFX folder without .mp3 extension
   * 
   * @param {string} soundName 
   */
  play(soundName) {
    if (!this.sound_files[soundName].playing() && this.enabled) {
      this.sound_files[soundName].volume(store.getState().musicVolume);
      this.sound_files[soundName].play();
    }
  }

  /**
   * Stops the filename from SFX folder without .mp3 extension
   * 
   * @param {string} soundName 
   */
  stop(soundName) {
    this.sound_files[soundName].stop();
  }

  /**
   * Sets the volume for given sound
   * 
   * @param {string} soundName 
   * @param {number} level 
   */
  volume(soundName, level) {
    this.sound_files[soundName].volume(level);
  }

  /**
   * Sets the volume for given sound
   * 
   * @param {string} soundName 
   * @param {boolean} level 
   */
   loop(soundName, val) {
    this.sound_files[soundName].loop(val);
  }

  state(soundName) {
    return this.sound_files[soundName].state();
  }

  /**
   * Fades sound, from values (0-1 or decimal), to alues (0-1 or decimal), duration miliseconds
   * 
   * @param {string} soundName 
   * @param {number} from 
   * @param {number} to 
   * @param {number} duration 
   */
  fade(soundName, from, to, duration) {
    this.sound_files[soundName].fade(from, to, duration);
  }

  autoPlay(soundName, val) {
    this.sound_files[soundName].on('load',this.play(soundName));
  }

}

const musicPlayer = new MusicPlayer();
export default musicPlayer;
